import React, { useState } from 'react';
import { Switcher } from '../../components/Form/Switcher/Switcher';
import { Card } from '../../components/Card/Card';
import { t } from '../../locales/translate';
import { Container } from '../../components/Container/Container';
import { useAsync, useData } from '../../model/data';
import { getAutoCancelStatus, updateAutoCancelStatus } from '../../model/settings';
import { useErrorHandler } from '../../util/util';
import { Spinner } from '../../components/Spinner/Spinner';

export function ServerSettings(): JSX.Element {
  return (
    <Container>
      <Card title={t.page.settings.title}>
        <OrdersAutoCancel />
      </Card>
    </Container>
  );
}

function OrdersAutoCancel(): JSX.Element {
  const [loading, error] = useAsync(() => getAutoCancelStatus());
  const [state, setState] = useState(useData((db) => db.get('autoCancelDisabled')));

  useErrorHandler(error);
  if (loading) {
    return <Spinner />;
  }

  async function onChange(): Promise<void> {
    await updateAutoCancelStatus();
    setState(!state);
  }

  return (
    <>
      <Switcher
        value={!state}
        onChange={onChange}
        labels={['enabled', 'disabled']}
        label={t.page.settings.ordersAutoCancel}
      />
    </>
  );
}
